<!-- @file 头部导航栏 -->
<template>
  <div>
    <data-export-portal class="p-data-export-portal" />
  </div>
</template>

<script>
import dataExportPortal from './components/data-export-portal';
export default {
  components: {
    dataExportPortal,
  },
};
</script>

<style lang="scss">
  .p-data-export-portal {
    position: absolute;
    right: 180px;
    top: 50%;
    transform: translate(0, -50%);
  }
</style>
